import { usePopularVerticals, useRecentVerticals } from '@pepper/ui'

import { getVerticalOptions, VerticalOptions } from '../helper'

type DataVerticalsProp = {
  companyId: string
  preDataset: PreDataProps | null
}

type DataVerticalsReturnType = {
  recentVerticalOptions: VerticalOptions[]
  popularVerticalOptions: VerticalOptions[]
}

export const useDataVerticals = ({
  companyId,
  preDataset,
}: DataVerticalsProp): DataVerticalsReturnType => {
  const { data: popularVerticals }: { data: VerticalID[] } =
    usePopularVerticals('popular-vertical')

  const { data: recentVerticals }: { data: VerticalID[] } =
    useRecentVerticals(companyId)

  let recentVerticalOptions: VerticalOptions[] = []
  let popularVerticalOptions: VerticalOptions[] = []

  if (!preDataset) return { recentVerticalOptions, popularVerticalOptions }

  recentVerticalOptions = getVerticalOptions(recentVerticals, preDataset)
  popularVerticalOptions = getVerticalOptions(popularVerticals, preDataset)

  return { recentVerticalOptions, popularVerticalOptions }
}
